export enum RuleType {
    '规则1' = 1,
    '规则2' = 2,
    '规则3' = 3,
}